module.exports = __webpack_public_path__ + "static/img/chuzhonghuaxue3.aaa185f7.jpg";